export default __webpack_public_path__ + "static/media/A29.fb52fb3f.png";